
import React, { useContext, useEffect, useState } from 'react'
import AdminSideBar from '../../components/adminSideBar/AdminSideBar'
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import FormInput from '../../components/formInput/FormInput';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import { communes, typeClients, wilayas } from '../../data';
import "./infoperson.css";
import { InfopersonContext } from '../../context/infopersonContext/InfopersonContext';
import { deleteCarteImage, getInfoperson, updateInfoperson } from '../../context/infopersonContext/apiCalls';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import ImageLoader from '../../components/imageLoader/ImageLoader';
import { AuthContext } from '../../context/authContext/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Infoperson() {
    const { dispatch, infoperson, message, isFetchingGet, errorGet, isFetchingUpdate, errorUpdate, isFetchingDelete, errorDelete } = useContext(InfopersonContext);
    const [errorInfoperson, setErrorInfoperson] = useState("");
    const [IsFetchingInfoperson, setIsFetchingInfoperson] = useState(false);
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [agence, setAgence] = useState("");
    const [entreprise, setEntreprise] = useState("");
    const [role, setRole] = useState("");
    const [nom, setNom] = useState("");
    const [tel1, setTel1] = useState("");
    const [tel2, setTel2] = useState("");
    const [email, setEmail] = useState("");
    const [wilaya, setWilaya] = useState(wilayas[0]);
    const [commune, setCommune] = useState(communes[0][0]);
    const [carteNumero, setCarteNumero] = useState("");
    const [carteFile, setCarteFile] = useState(null);

    useEffect(() => {
        if (errorGet !== false) {
            setErrorInfoperson(errorGet);
        }
        if (errorUpdate !== false) {
            setErrorInfoperson(errorUpdate);
        }
    }, [errorGet, errorUpdate]);

    useEffect(() => {
        setIsFetchingInfoperson(isFetchingGet || isFetchingUpdate);
    }, [isFetchingGet, isFetchingUpdate]);

    useEffect(() => {
        if (message != "") {
            navigate('/')
        }
    }, [message]);

    useEffect(() => {
        getInfoperson(dispatch);
        setErrorInfoperson('');
        dispatch({
            type: "CLEAR_FETCH_ERROR"
        })
    }, [])

    useEffect(() => {
        if (Object.keys(infoperson).length !== 0) {
            setUsername(infoperson.username);
            setAgence(infoperson.Agence ? infoperson.Agence.nom : "");
            setEntreprise(infoperson.Entreprise ? infoperson.Entreprise.nom : "");
            setRole(typeClients.filter(item => item.id === infoperson.Role.id)[0] ? typeClients.filter(item => item.id === infoperson.Role.id)[0]['nom'] : "");

            setNom(infoperson.Userinfo.nom);
            setTel1(infoperson.Userinfo.tel1);
            setTel2(infoperson.Userinfo.tel2 || "");
            setEmail(infoperson.Userinfo.email || "");
            setWilaya(wilayas.filter(item => item.id === infoperson.Userinfo.wilaya)[0]);
            setCommune(communes[infoperson.Userinfo.wilaya].filter(item => item.id === infoperson.Userinfo.commune)[0]);
            setCarteNumero(infoperson.Userinfo.numero_carte || "");
            setCarteFile(null)
        }
    }, [infoperson])


    const updateInfopersonHandler = () => {
        if (nom.trim() == "") {
            setErrorInfoperson(`Vous devez compléter le Nom`);
            return;
        }
        if (tel1.trim() == "") {
            setErrorInfoperson(`Vous devez compléter le Téléphone`);
            return;
        }
        if (carteNumero.length !== 18) {
            setErrorInfoperson(`Numero de carte non valide`);
            return;
        }
        setErrorInfoperson('');
        updateInfoperson(dispatch, nom, tel1, tel2, email, wilaya.id, commune.id, carteNumero, carteFile);
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="infoperson" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Infors :</span>
                </div>

                <div className='box-success' style={{ "maxWidth": "none", "margin": "0 0 20px" }}>Pour toutes informations, contactez-nous au {user.telephone}</div>

                {
                    (errorGet || errorUpdate) ? <ErrorComponent error={errorInfoperson} /> : (
                        IsFetchingInfoperson ? <LoadingComponent /> : (
                            <div className="content infoperson">
                                <div className="box">
                                    <div className="box-title" style={{ marginBottom: "25px", }}>Infors Personnelles</div>
                                    {errorInfoperson !== "" && (<div style={{ marginBottom: "25px" }} className='box-error'>{errorInfoperson}</div>)}
                                    {errorDelete !== false && (<div style={{ marginBottom: "25px" }} className='box-error'>{errorDelete}</div>)}
                                    <div className="box-content">
                                        <div className='side-to-side'>
                                            <FormInput label="Username" itemInput={username} setItemInput={setUsername} auth inactive />
                                            {
                                                role !== "Client" && (
                                                    <FormInput label="Role" itemInput={role} setItemInput={setRole} auth inactive />
                                                )
                                            }
                                        </div>
                                        <div className='side-to-side'>
                                            <FormInput label="Nom" itemInput={nom} setItemInput={setNom} auth />
                                            {
                                                infoperson.Entreprise && (
                                                    <FormInput label="Entreprise" itemInput={entreprise} setItemInput={setEntreprise} auth inactive />
                                                )
                                            }
                                        </div>
                                        <div className='side-to-side'>
                                            <DropDownComponent data={wilayas} itemChoisir={wilaya} setItemChoisir={setWilaya} />
                                            <DropDownComponent data={communes[wilaya.id]} itemChoisir={commune} setItemChoisir={setCommune} />
                                        </div>
                                        <div className='side-to-side'>
                                            <FormInput label="Tel1" itemInput={tel1} setItemInput={setTel1} auth />
                                            <FormInput label="Tel2" itemInput={tel2} setItemInput={setTel2} auth />
                                        </div>
                                        <FormInput label="Email" itemInput={email} setItemInput={setEmail} auth />
                                        <FormInput label="Numero du Carte" itemInput={carteNumero} setItemInput={setCarteNumero} auth istype='number' />
                                        <ImageLoader imageLabel={"Attacher Carte"} fileDecharge={carteFile} setFileDecharge={setCarteFile} imgUrl={infoperson.Userinfo && infoperson.Userinfo.image_carte} subPath='uploadCarte' />
                                        <div className='button' onClick={updateInfopersonHandler} style={isFetchingUpdate ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                            <span>
                                                {isFetchingUpdate ? "Modifier ..." : "Modifier"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    )
                }
            </div>
        </div>
    )
}
